module.exports = __webpack_public_path__ + "img/icon_messenger_white.0dce480.svg";